module.exports = function getResource(label, vars = []) {
    let resources = { viewAll: 'View All' };
    return resources[label];
};
